// Resolve the committed import before exposing the day's roster. Browser-local
// import previews are not authoritative and may outlive a cleared schedule.
export async function loadJourneyRoster(api, boutique, date, weekStart) {
  const options = { params: { refresh: Date.now() }, headers: { "Cache-Control": "no-cache" } };
  const [daily, imported] = await Promise.all([
    api.get(`/daily-logs/${boutique}/${date}`, options),
    api.get(`/schedules/zenoti/${boutique}/${weekStart}`, options).catch((error) => {
      if (error.response?.status === 404) return { data: null };
      throw error;
    }),
  ]);
  return mergeJourneyRoster(daily.data, imported.data, date);
}

export function mergeJourneyRoster(log, schedule, date) {
  if (!schedule) return log;
  const shifts = schedule.shifts_by_date || {};
  const profiles = { ...schedule.cross_center_people, ...schedule.employee_profiles };
  const roster = (log.roster || []).map((person) => {
    const shift = shifts[person.employee_id]?.[date];
    if (!shift || person.shift_override || person.shift_source === "schedule") return person;
    return { ...person, shift, shift_source: "zenoti" };
  });
  const existing = new Set(roster.map((person) => person.employee_id));
  Object.entries(shifts).forEach(([employee_id, days]) => {
    const profile = profiles[employee_id];
    if (existing.has(employee_id) || !days[date] || !profile) return;
    roster.push({
      employee_id, employee_name: profile.employee_name, role: profile.role || "massage_therapist",
      shift: days[date], shift_source: "zenoti", shift_override: false, cross_center: !!profile.cross_center,
      call_am: false, call_pm: false, sweep_1: false, sweep_2: false, sweep_3: false,
      mbr_conversion: null, mtd_reviews: 0,
    });
    existing.add(employee_id);
  });
  return { ...log, roster: roster.map((person) => ({
    ...person,
    absence_status: schedule.absence_records?.[person.employee_id]?.[date]?.status ?? person.absence_status ?? "",
  })) };
}
